export default {
  subtitle: {
    en: 'PROJECTS',
    ja: 'プロジェクト'
  }
}
